'use strict';


function absurd($$void) {
  var _nextVoid = $$void._0;
  while(true) {
    var nextVoid = _nextVoid;
    _nextVoid = nextVoid._0;
    continue ;
  };
}

var show = absurd;

exports.absurd = absurd;
exports.show = show;
/* No side effect */
